<template>
      <div class="ruleVaccinationEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'ruleVaccination', params: {} }">
          Rule Vaccination
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'ruleVaccinationEdit', params:{id: id} }">
            Edit Rule Vaccination
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Rule Vaccination</v-card-title>
          <v-card-text>
            <ruleVaccination-form :id="id"></ruleVaccination-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import RuleVaccinationForm from './RuleVaccinationForm.vue';

    export default {
      name: 'ruleVaccination',
      data () {
        return {
          id: null
        }
      },
      components: {
        RuleVaccinationForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    